var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.003.938.929 5.879a.867.867 0 0 0-.087 1.144l.079.09 5.082 4.95a.956.956 0 0 0 1.333 0 .906.906 0 0 0 .017-1.283L3.909 7.426h12.496a.927.927 0 1 0 0-1.853L3.91 5.572l3.427-3.336A.906.906 0 0 0 7.353.954L7.336.938a.956.956 0 0 0-1.333 0Z",
    fill: "#E96358"
  })));
};
export default SvgArrowLeft;